import * as React from "react";
import { Redirect, useLocation } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import {
    BAM_WORKFLOWS_ROUTE,
    deriveRedirectTarget,
    detectApplicationFromPath,
    WORKFLOWS_ROUTE,
} from "components/router/Routes";
import { Application } from "store/application";

export default function WorkflowsView(): JSX.Element {
    const { pathname } = useLocation();
    const isRouteEnabled = useIsRouteEnabled();

    const route = detectApplicationFromPath(pathname) === Application.BAM ? BAM_WORKFLOWS_ROUTE : WORKFLOWS_ROUTE;
    const target = deriveRedirectTarget(route, isRouteEnabled);

    return <Redirect to={target.path} />;
}
